// Renaissance Masters & Scientific Visionaries Data - Group Two (Second 6 Characters)

// Michelangelo's workout programs
const michelangeloPrograms = [
    {
        id: 'sistine-chapel-endurance',
        name: 'Sistine Chapel Endurance',
        description: 'Overhead conditioning for four years of ceiling work - building strength that defies gravity',
        pattern: 'w@^_da',
        reps: 16,
        sets: 4,
        focus: 'Overhead Mastery'
    },
    {
        id: 'david-sculpture-strength',
        name: 'David Sculpture Strength',
        description: 'Marble-carving power that transforms raw stone into perfect human form through sheer will',
        pattern: '^w@d_a',
        reps: 17,
        sets: 5,
        focus: 'Sculpting Power'
    },
    {
        id: 'divine-comedy-training',
        name: 'Divine Comedy Training',
        description: 'Spiritual conditioning that elevates physical training into artistic transcendence',
        pattern: '@_aw^d',
        reps: 33,
        sets: 3,
        focus: 'Divine Transcendence'
    },
    {
        id: 'renaissance-master-protocol',
        name: 'Renaissance Master Protocol',
        description: 'Multi-disciplinary training combining sculpture, painting, and architectural perfection',
        pattern: 'd^a@w_',
        reps: 20,
        sets: 4,
        focus: 'Master Artisan'
    },
    {
        id: 'pieta-precision-workout',
        name: 'Pietà Precision Workout',
        description: 'Delicate strength training that creates beauty through controlled power and emotional depth',
        pattern: '_a@^wd',
        reps: 24,
        sets: 3,
        focus: 'Artistic Precision'
    },
    {
        id: 'buonarroti-legacy-mastery',
        name: 'Buonarroti Legacy Mastery',
        description: 'The complete training system of history\'s greatest artist who defined Renaissance perfection',
        pattern: 'w@^_da!',
        reps: 89,
        sets: 3,
        focus: 'Eternal Artistry'
    }
];

// Galileo Galilei's workout programs
const galileoGalileiPrograms = [
    {
        id: 'telescope-observation-training',
        name: 'Telescope Observation Training',
        description: 'Steady precision conditioning for hours of celestial observation and groundbreaking discovery',
        pattern: 'lcrobs',
        reps: 22,
        sets: 4,
        focus: 'Steady Observation'
    },
    {
        id: 'eppur-si-muove-conditioning',
        name: 'Eppur Si Muove Conditioning',
        description: 'Truth-defending strength for those who dare to challenge established doctrine with facts',
        pattern: 'bcrlso',
        reps: 19,
        sets: 4,
        focus: 'Truth Defense'
    },
    {
        id: 'inquisition-resistance-workout',
        name: 'Inquisition Resistance Workout',
        description: 'Mental and physical fortitude to withstand persecution while advancing human knowledge',
        pattern: 'sobclr',
        reps: 16,
        sets: 5,
        focus: 'Knowledge Perseverance'
    },
    {
        id: 'mathematical-universe-protocol',
        name: 'Mathematical Universe Protocol',
        description: 'Systematic training based on the mathematical laws that govern all physical motion',
        pattern: 'rolsbc',
        reps: 27,
        sets: 3,
        focus: 'Mathematical Precision'
    },
    {
        id: 'starry-messenger-training',
        name: 'Starry Messenger Training',
        description: 'Revolutionary conditioning that prepares messengers of new scientific truths',
        pattern: 'clbsor',
        reps: 21,
        sets: 4,
        focus: 'Scientific Revolution'
    },
    {
        id: 'father-of-science-mastery',
        name: 'Father of Science Mastery',
        description: 'The complete training regimen that established the modern scientific method',
        pattern: 'lcrobs!',
        reps: 63,
        sets: 3,
        focus: 'Scientific Foundation'
    }
];

// Isaac Newton's workout programs
const isaacNewtonPrograms = [
    {
        id: 'apple-gravity-discovery',
        name: 'Apple Gravity Discovery',
        description: 'Universal force training that reveals the hidden laws governing all motion and attraction',
        pattern: 'tmifka',
        reps: 18,
        sets: 4,
        focus: 'Universal Laws'
    },
    {
        id: 'principia-mathematical-conditioning',
        name: 'Principia Mathematical Conditioning',
        description: 'Revolutionary mathematical training that describes the mechanics of the entire universe',
        pattern: 'akmfit',
        reps: 67,
        sets: 3,
        focus: 'Mathematical Universe'
    },
    {
        id: 'calculus-invention-workout',
        name: 'Calculus Invention Workout',
        description: 'Mind-expanding training that creates entirely new mathematical tools for understanding change',
        pattern: 'fiatmk',
        reps: 25,
        sets: 4,
        focus: 'Mathematical Innovation'
    },
    {
        id: 'optics-light-protocol',
        name: 'Optics Light Protocol',
        description: 'Illuminating training that breaks white light into component colors and understanding',
        pattern: 'ktamif',
        reps: 29,
        sets: 3,
        focus: 'Light Mastery'
    },
    {
        id: 'royal-society-training',
        name: 'Royal Society Training',
        description: 'Institutional conditioning that establishes the foundations of organized scientific inquiry',
        pattern: 'ikmaft',
        reps: 23,
        sets: 4,
        focus: 'Scientific Institution'
    },
    {
        id: 'greatest-scientist-mastery',
        name: 'Greatest Scientist Mastery',
        description: 'The ultimate training system that revolutionized mathematics, physics, and human understanding',
        pattern: 'tmifka!',
        reps: 84,
        sets: 3,
        focus: 'Scientific Genius'
    }
];

// Albert Einstein's workout programs
const albertEinsteinPrograms = [
    {
        id: 'relativity-spacetime-training',
        name: 'Relativity Spacetime Training',
        description: 'Mind-bending conditioning that warps understanding of space, time, and reality itself',
        pattern: 'ehkmvp',
        reps: 26,
        sets: 4,
        focus: 'Spacetime Mastery'
    },
    {
        id: 'e-equals-mc-squared-conditioning',
        name: 'E=mc² Conditioning',
        description: 'Energy-mass equivalence training that unlocks the fundamental relationship between matter and energy',
        pattern: 'mvpehk',
        reps: 99,
        sets: 3,
        focus: 'Energy-Mass Unity'
    },
    {
        id: 'gedanken-experiment-workout',
        name: 'Gedanken Experiment Workout',
        description: 'Thought experiment conditioning that uses imagination to unlock the deepest secrets of reality',
        pattern: 'khmvpe',
        reps: 31,
        sets: 4,
        focus: 'Thought Experiments'
    },
    {
        id: 'quantum-god-protocol',
        name: 'Quantum God Protocol',
        description: 'Divine mystery training for those who believe God does not play dice with the universe',
        pattern: 'pevkhm',
        reps: 19,
        sets: 5,
        focus: 'Quantum Philosophy'
    },
    {
        id: 'unified-field-training',
        name: 'Unified Field Training',
        description: 'Ultimate synthesis conditioning seeking the single theory that explains all forces',
        pattern: 'hmpvek',
        reps: 42,
        sets: 3,
        focus: 'Universal Unity'
    },
    {
        id: 'genius-of-century-mastery',
        name: 'Genius of Century Mastery',
        description: 'The complete training of the mind that redefined reality and launched the atomic age',
        pattern: 'ehkmvp!',
        reps: 76,
        sets: 3,
        focus: 'Reality Revolution'
    }
];

// Nikola Tesla's workout programs
const nikolaTeslaPrograms = [
    {
        id: 'alternating-current-conditioning',
        name: 'Alternating Current Conditioning',
        description: 'Electrical flow training that powers the entire modern world through oscillating energy',
        pattern: 'gvyqnu',
        reps: 60,
        sets: 4,
        focus: 'Electrical Flow'
    },
    {
        id: 'wireless-power-transmission',
        name: 'Wireless Power Transmission',
        description: 'Revolutionary energy training that transmits power through the air without wires',
        pattern: 'quvgny',
        reps: 28,
        sets: 4,
        focus: 'Wireless Energy'
    },
    {
        id: 'wardenclyffe-tower-workout',
        name: 'Wardenclyffe Tower Workout',
        description: 'Global communication conditioning that connects the entire world through electrical resonance',
        pattern: 'ynguvq',
        reps: 62,
        sets: 3,
        focus: 'Global Connection'
    },
    {
        id: 'mad-scientist-protocol',
        name: 'Mad Scientist Protocol',
        description: 'Eccentric genius training for visionaries whose ideas seem impossible until they work',
        pattern: 'uvqnyg',
        reps: 35,
        sets: 3,
        focus: 'Visionary Madness'
    },
    {
        id: 'electrical-wizard-training',
        name: 'Electrical Wizard Training',
        description: 'Lightning mastery conditioning that harnesses the raw power of electrical storms',
        pattern: 'nvguqy',
        reps: 30,
        sets: 4,
        focus: 'Lightning Mastery'
    },
    {
        id: 'man-who-invented-future',
        name: 'Man Who Invented Future',
        description: 'The complete training system of the inventor who created the electrical foundation of modernity',
        pattern: 'gvyqnu!',
        reps: 123,
        sets: 3,
        focus: 'Future Creation'
    }
];

// Pablo Picasso's workout programs
const pabloPicassoPrograms = [
    {
        id: 'cubist-revolution-training',
        name: 'Cubist Revolution Training',
        description: 'Multi-perspective conditioning that sees reality from all angles simultaneously',
        pattern: 'zj|+;a',
        reps: 14,
        sets: 5,
        focus: 'Multi-Perspective Vision'
    },
    {
        id: 'blue-period-conditioning',
        name: 'Blue Period Conditioning',
        description: 'Melancholic strength training that transforms personal sadness into universal beauty',
        pattern: '+;azj|',
        reps: 23,
        sets: 4,
        focus: 'Emotional Transformation'
    },
    {
        id: 'guernica-protest-workout',
        name: 'Guernica Protest Workout',
        description: 'Anti-war conditioning that channels political outrage into powerful artistic statement',
        pattern: 'j|z+a;',
        reps: 64,
        sets: 3,
        focus: 'Political Art Power'
    },
    {
        id: 'demoiselles-avignon-protocol',
        name: 'Demoiselles d\'Avignon Protocol',
        description: 'Revolutionary training that shatters traditional artistic conventions forever',
        pattern: ';az|+j',
        reps: 27,
        sets: 4,
        focus: 'Artistic Revolution'
    },
    {
        id: 'prolific-genius-training',
        name: 'Prolific Genius Training',
        description: 'Endless creativity conditioning that produces over 50,000 artworks in a lifetime',
        pattern: '|+j;za',
        reps: 166,
        sets: 3,
        focus: 'Infinite Creativity'
    },
    {
        id: 'most-famous-artist-mastery',
        name: 'Most Famous Artist Mastery',
        description: 'The complete training system that revolutionized art and created modern artistic expression',
        pattern: 'zj|+;a!',
        reps: 91,
        sets: 3,
        focus: 'Artistic Immortality'
    }
];

// Main Renaissance Masters & Scientific Visionaries trainers data object - Group Two
const historyTwoTrainersData = {
    'michelangelo': {
        id: 'michelangelo',
        name: 'Michelangelo',
        specialization: 'Sculptural Power & Ceiling Endurance Training',
        image: '/assets/images/michelangelo.jpg',
        experience: '89+ years',
        category: 'renaissance-masters',
        color: '#8B4513',
        secondaryColor: '#F5DEB3',
        intro: `The divine artist who painted the Sistine Chapel ceiling and carved David from marble. His training develops the superhuman endurance needed for years of overhead work and the precise strength to transform stone into living beauty. "I saw the angel in the marble and carved until I set him free."`,
        programs: michelangeloPrograms
    },
    'galileo-galilei': {
        id: 'galileo-galilei',
        name: 'Galileo Galilei',
        specialization: 'Telescopic Precision & Scientific Method Training',
        image: '/assets/images/galileo-galilei.jpg',
        experience: '78+ years',
        category: 'renaissance-masters',
        color: '#1E3A8A',
        secondaryColor: '#3B82F6',
        intro: `The father of modern science who turned his telescope to the heavens and revolutionized human understanding. His training builds the steady precision needed for observation and the courage to defend truth against persecution. "And yet it moves."`,
        programs: galileoGalileiPrograms
    },
    'isaac-newton': {
        id: 'isaac-newton',
        name: 'Isaac Newton',
        specialization: 'Mathematical Physics & Universal Law Training',
        image: '/assets/images/isaac-newton.jpg',
        experience: '84+ years',
        category: 'renaissance-masters',
        color: '#7C3AED',
        secondaryColor: '#A78BFA',
        intro: `The greatest scientist who ever lived, Newton discovered gravity, invented calculus, and described the mathematical laws governing the universe. His training develops systematic thinking and the mental strength to revolutionize human understanding. "If I have seen further, it is by standing on the shoulders of giants."`,
        programs: isaacNewtonPrograms
    },
    'albert-einstein': {
        id: 'albert-einstein',
        name: 'Albert Einstein',
        specialization: 'Relativity Theory & Thought Experiment Training',
        image: '/assets/images/albert-einstein.jpg',
        experience: '76+ years',
        category: 'renaissance-masters',
        color: '#6B7280',
        secondaryColor: '#9CA3AF',
        intro: `The genius who redefined reality with relativity theory and unlocked the secret of mass-energy equivalence. His training uses thought experiments and imagination to push beyond the boundaries of conventional thinking. "Imagination is more important than knowledge."`,
        programs: albertEinsteinPrograms
    },
    'nikola-tesla': {
        id: 'nikola-tesla',
        name: 'Nikola Tesla',
        specialization: 'Electrical Innovation & Wireless Power Training',
        image: '/assets/images/nikola-tesla.jpg',
        experience: '87+ years',
        category: 'renaissance-masters',
        color: '#1E40AF',
        secondaryColor: '#3B82F6',
        intro: `The electrical wizard who invented alternating current and envisioned wireless power transmission. His training harnesses the raw power of electricity and develops the visionary thinking needed to invent the future. "The present is theirs; the future, for which I really worked, is mine."`,
        programs: nikolaTeslaPrograms
    },
    'pablo-picasso': {
        id: 'pablo-picasso',
        name: 'Pablo Picasso',
        specialization: 'Cubist Revolution & Multi-Perspective Training',
        image: '/assets/images/pablo-picasso.jpg',
        experience: '91+ years',
        category: 'renaissance-masters',
        color: '#D97706',
        secondaryColor: '#F59E0B',
        intro: `The revolutionary artist who invented Cubism and created over 50,000 artworks in his lifetime. His training develops the ability to see reality from multiple angles simultaneously and the creative power to constantly reinvent artistic expression. "Every act of creation is first an act of destruction."`,
        programs: pabloPicassoPrograms
    }
};

// Export the data
export default historyTwoTrainersData;